import http from "@/utils/http";
import {
  LoginRequest,
  UserResult,
  RegisterReq,
  RegisterRes,
  ResultBase,
  InitPasswordReq,
  SetPasswordByFindReq
} from "/#/JHT";

// 登录
export async function login(data: LoginRequest) {
  const res = await http.post<any, UserResult>("/plat/user/login", data);
  return res;
}

// 注册
export async function register(data: RegisterReq) {
  const res = await http.post<any, RegisterRes>("/plat/user/register", data);
  return res;
}

// 初始化密码
export async function initPassword(data: InitPasswordReq) {
  const res = await http.post<any, ResultBase>(
    "/plat/user/initPassword",
    data,
    {
      headers: {
        user_token: localStorage.c_userToken
      }
    }
  );
  return res;
}

// 修改密码-找回密码
export async function setPasswordByFind(data: SetPasswordByFindReq) {
  const res = await http.post<any, ResultBase>(
    "/plat/user/setPasswordByFind",
    data
  );
  return res;
}
